import React, {useEffect, useRef} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {Popover as BsPopover} from "bootstrap";

const Popover = ({ title, content, trigger = 'click', placement = 'right' }) => {
	const bootstrapPopover = useRef(null);

	useEffect(() => {
		new BsPopover(bootstrapPopover.current, {
			content: content,
			title: title ?? '',
			trigger: trigger,
			placement: placement,
			html: true
		})

		bootstrapPopover.current.addEventListener('show.bs.popover', function () {
			bootstrapPopover.current.classList.add('popover-active');
		});
		bootstrapPopover.current.addEventListener('hide.bs.popover', function () {
			bootstrapPopover.current.classList.remove('popover-active');
		});
	})

	return (
		<span className="fs-6"
			ref={bootstrapPopover}>
			<FontAwesomeIcon icon={faInfoCircle} />
		</span>
	)
};
export default Popover;
